import {useState,useEffect} from "react";
import ImageWithBasePath from "../../../img";
import FeatherIcon from "feather-icons-react";
import {Link,useLocation} from "react-router-dom";
import Scrollbar from "react-perfect-scrollbar-z";
import "react-perfect-scrollbar-z/build/styles.css";
import {all_routes} from "../../../../feature-module/router/all_routes";
import {setExpandMenu,setMiniSidebar} from "../../../redux/sidebarSlice";
import {useDispatch} from "react-redux";
// -- biz9 --
import {Title} from "../../../../constant";
import {Storage} from "../../../../project";
import {Str} from "biz9-utility";
const Dashboard_Sidebar_User = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [hide_side_bar,setHideSideBar] = useState(props.hide_side_bar);
    const [side_bar_select,setSideBarSelect] = useState(Storage.get_dashboard_side_bar_type());
    const handleToggleMiniSidebar = () => {
        const body = document.body;
        if (body.classList.contains("mini-sidebar")) {
            body.classList.remove("mini-sidebar");
            body.classList.add("expand-menu");
            dispatch(setMiniSidebar(false));
            localStorage.setItem("sidebarState", "expand-menu"); // Store state in localStorage
        } else {
            body.classList.add("mini-sidebar");
            body.classList.remove("expand-menu");
            dispatch(setMiniSidebar(true));
            localStorage.setItem("sidebarState", "mini-sidebar"); // Store state in localStorage
        }
    };
    useEffect(() => {
            setSideBarSelect(props.side_bar_select);
            const savedState = localStorage.getItem("sidebarState");
            const body = document.body;
            if (savedState === "mini-sidebar") {
            body.classList.add("mini-sidebar");
            body.classList.remove("expand-menu");
            dispatch(setMiniSidebar(true));
            } else {
            body.classList.add("expand-menu");
            body.classList.remove("mini-sidebar");
            dispatch(setMiniSidebar(false));
            }
            }, [dispatch,props.side_bar_select]);
    async function btn_side_bar_table(table) {
        Storage.post_dashboard_side_bar(table);
    };
    const onMouseEnter = () => {
        const body = document.body;
        if (body.classList.contains("mini-sidebar")) {
            body.classList.add("expand-menu");
            dispatch(setExpandMenu(true));
            localStorage.setItem("sidebarState", "expand-menu"); // Store state in localStorage
        }
    };
    const onMouseLeave = () => {
        const body = document.body;
        if (body.classList.contains("mini-sidebar")) {
            body.classList.remove("expand-menu");
            dispatch(setExpandMenu(false));
            localStorage.setItem("sidebarState", "mini-sidebar"); // Store state in localStorage
        }
    };
    return (
            <div hidden={hide_side_bar}
            className="sidebar"
            id="sidebar"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            >
            <div className="sidebar-logo">
            <div className="d-flex align-items-center justify-content-between">
            <Link to={"#"} className="logo logo-normal">
            <ImageWithBasePath src="/assets/img/logo.png" alt="Logo" />
            </Link>
            <Link to={"#"} className="logo-small">
            <ImageWithBasePath
            src="/assets/img/logo-small.png"
            alt="Logo"
            className="img-fluid"
            />
            </Link>
            <Link to={"#"} className="dark-logo">
            <ImageWithBasePath
            src="/assets/img/dark-logo.png"
            alt="Logo"
            className="img-fluid"
            />
            </Link>
            <Link
            id="toggle_btn"
            to="#"
            className="active"
            onClick={() => {
                handleToggleMiniSidebar();
            }}
    >
        <i className="ti ti-arrow-bar-right" />
        </Link>
        </div>
        </div>
        <div className="sidebar-inner slimscroll">
        <Scrollbar maxHeight="100vh" always>
        <div id="sidebar-menu" className="sidebar-menu">
        <ul>
        <li>
        <ul>

        <li>
        <Link to={all_routes.dashboard_user_home} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_DASHBOARD)}}} className={side_bar_select == Title.USER_SIDE_BAR_DASHBOARD ? "active" : ""}>
        <FeatherIcon icon="settings" />
        <span>{Title.USER_SIDE_BAR_DASHBOARD}</span>
        </Link>
        </li>

        <li>
        <Link to={all_routes.dashboard_user_app} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_APPZ)}}} className={side_bar_select == Title.USER_SIDE_BAR_APPZ ? "active" : ""}>
        <FeatherIcon icon="cast" />
        <span>{Title.USER_SIDE_BAR_APPZ}</span>
        </Link>
        </li>

       <li>
        <Link to={all_routes.dashboard_user_favorite} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_FAVORITE)}}} className={side_bar_select == Title.USER_SIDE_BAR_FAVORITE ? "active" : ""}>
        <FeatherIcon icon="star" />
        <span>{Title.USER_SIDE_BAR_FAVORITE}</span>
        </Link>
        </li>

        <li>
        <Link  hidden={true} to={all_routes.dashboard_user_order} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_ORDER)}}} className={side_bar_select == Title.USER_SIDE_BAR_ORDER ? "active" : ""}>
        <FeatherIcon icon="dollar-sign" />
        <span>{Title.USER_SIDE_BAR_ORDER}</span>
        </Link>
        </li>

        <li>
        <Link hidden={true} to={all_routes.dashboard_user_review} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_REVIEW)}}} className={side_bar_select == Title.USER_SIDE_BAR_REVIEW ? "active" : ""}>
        <FeatherIcon icon="smile" />
        <span>{Title.USER_SIDE_BAR_REVIEW}</span>
        </Link>
        </li>

        <li>
        <Link  hidden={true} to={all_routes.dashboard_user_stat} onClick={(e)=>{{btn_side_bar_table(Title.USER_SIDE_BAR_STAT)}}} className={side_bar_select == Title.USER_SIDE_BAR_STAT ? "active" : ""}>
        <FeatherIcon icon="smile" />
        <span>{Title.USER_SIDE_BAR_STAT}</span>
        </Link>
        </li>

        </ul>
        </li>
        </ul>
        <div className="sidebar-footer">
        <Link to={"#"} target="_blank">
        <i className="ti ti-logout me-2" />
        <span>Logout</span>
        </Link>
        </div>
        </div>
        </Scrollbar>
        </div>
        </div>
        );
};
export default Dashboard_Sidebar_User;
